const formatDate = (dateStr: string, options?: Intl.DateTimeFormatOptions) => {
  const dateObj = new Date(dateStr)
  const formattedDate = dateObj.toLocaleDateString('en-GB', options)
  return formattedDate
}

export default formatDate
